define(function (require, exports, module) {
    var CmsDapiArticle = require('./cmsDapi/CmsDapiArticle');

    function CmsDapiArticleListModel (data) {
        this.articles = [];
        this.articlesById = {};
        if (data) {
            this.parseData(data);
        }
    }

    CmsDapiArticleListModel.prototype = {
        hasArticles: false,
        count: 0,
        parseData: function (data) {
            this.parseArticles(data.items);
        },
        parseArticles: function (items) {
            var parsedArticles = this.articles;
            if (items && items.length) {
                var articlesById = this.articlesById;
                var i = 0;
                var len = items.length;
                var article;

                for (; i < len; i++) {
                    article = new CmsDapiArticle(items[i], false);
                    // Add valid articles, and ignore recaps
                    if (article.slug && article.isRecap === false) {
                        parsedArticles.push(article);
                        articlesById[article.slug] = article;
                    }
                }
            }
            this.count = parsedArticles.length;
            this.hasArticles = this.count > 0;
        }
    };

    return CmsDapiArticleListModel;
});

